import script from "./summary-statement-grid.vue?vue&type=script&setup=true&lang=ts"
export * from "./summary-statement-grid.vue?vue&type=script&setup=true&lang=ts"

import "./summary-statement-grid.vue?vue&type=style&index=0&id=681b9128&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-681b9128"]])

export default __exports__